// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"1f3a2121","3094":"cd84ba51","5020":"80162876","5066":"57d5ace2","7945":"aec78970"}[chunkId] + ".css";
};